export default __webpack_public_path__ + "static/media/Union_icon.d2a8e5f1.png";